export default __webpack_public_path__ + "static/media/minechain.2bfb068e.png";